<div
  class="body-container"
  [ngStyle]="{
    gap: inApprovalPage ? '8px' : '32px',
  }">
  <div *ngIf="!inApprovalPage">
    {{ 'version.create.dialog.number.text' | translate }}
  </div>
  <div class="name-container">
    <div data-cy="vessel-folder-req-approval-requester-modal-version-number">
      {{ 'version.create.dialog.number.recommended-version' | translate: { recommendedVersion } }}
    </div>
    <div
      class="info-button"
      data-cy="vessel-folder-req-approval-requester-modal-why-version-selected-button"
      (click)="openInfo()">
      {{ 'version.create.dialog.number.info.button' | translate }}
    </div>
  </div>
  <div class="bottom-container" data-cy="vessel-folder-req-approval-requester-modal-custom-version">
    <div *ngIf="!inApprovalPage">
      {{ 'version.create.dialog.number.bottom.text' | translate }}
    </div>
    <div class="checkbox-container">
      <input
        class="checkbox"
        type="checkbox"
        data-cy="vessel-folder-req-approval-requester-modal-custom-version-checkbox"
        [value]="customizeVersion"
        (click)="toggleClick($event)" />
      <div
        for="customizeVersion"
        data-cy="vessel-folder-req-approval-requester-modal-custom-version-label">
        {{ 'version.create.dialog.number.checkbox.text' | translate }}
      </div>
    </div>
    <form class="input-form" *ngIf="customizeVersion">
      <app-channel-text-input
        [value]="versionName"
        [label]="'version.create.dialog.number.input.legend'"
        [name]="'versionName'"
        [inputError]="validationErrors?.versionName"
        (onInputChange)="updateVersionName($event.value)"
        (onFocusChange)="updateVersionName($event.value)"></app-channel-text-input>
    </form>
  </div>
</div>
